module.exports = __webpack_public_path__ + "static/header_title_de-a38e22a39b7dbc938a73401b035e5ff8.png";